import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const TABLE_ROW_CLASS_NAME = 'TableRow';

export const TABLE_ROW_CLASS_SLOTS = ['root'] as const;

export type TableRowClassSlot = (typeof TABLE_ROW_CLASS_SLOTS)[number];

export interface TableRowClasses {
	root: string;

	isActive: string;
	isSelected: string;
}

export type TableRowClassKey = keyof TableRowClasses;

export const getTableRowUtilityClass = (slot: string) =>
	generateUtilityClass(TABLE_ROW_CLASS_NAME, slot);

export const tableRowClasses = generateUtilityClasses<keyof TableRowClasses>(
	TABLE_ROW_CLASS_NAME,
	['root', 'isActive', 'isSelected'],
);
export default tableRowClasses;
